import { render, staticRenderFns } from "./ViewEncounters.vue?vue&type=template&id=1585d59a&scoped=true&"
import script from "./ViewEncounters.vue?vue&type=script&lang=js&"
export * from "./ViewEncounters.vue?vue&type=script&lang=js&"
import style0 from "./ViewEncounters.vue?vue&type=style&index=0&id=1585d59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585d59a",
  null
  
)

export default component.exports